import React from "react";
import { Box, Button, Divider, Typography } from "@mui/material";

import { inputLayerGroups, LayerIds } from "fond/layers";
import { useAppDispatch, useAppSelector } from "fond/utils/hooks";
import { isExtendedPlannerProject } from "fond/utils/project";
import { useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

import { closePolygonSelect, deleteLayerFeatures, getCurrentProject } from "../redux";

import { Alert, AlertTitle } from "./InputDataPanel.styles";

const RemoveData: React.FC = () => {
  const dispatch = useAppDispatch();
  const { clear, goBack } = useStackedNavigationContext();
  const { activeLayerGroupId } = useAppSelector((state) => state.project);
  const layerGroup = inputLayerGroups[activeLayerGroupId];
  const project = useAppSelector((state) => getCurrentProject(state.project));

  const onRemove = async () => {
    const layersToDelete = inputLayerGroups[activeLayerGroupId].layers.map(({ id }) => id);
    if (inputLayerGroups[activeLayerGroupId] === inputLayerGroups.inAddress && !isExtendedPlannerProject(project)) {
      // If we are removing the address layer, we also remove the parcel layer
      layersToDelete.push(LayerIds.inParcel);
    }
    dispatch(deleteLayerFeatures(layersToDelete, activeLayerGroupId));
    clear();
  };

  const handleBack = () => {
    dispatch(closePolygonSelect());
    goBack();
  };

  return (
    <>
      <StackedNavigationHeader onBackButtonClick={handleBack} title="Remove Data" />
      <Box px={1} data-testid="remove-data-alert-box">
        <Typography fontWeight="500" mb={2}>
          {layerGroup ? layerGroup.name : "Unknown Layer Group"}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          <AlertTitle data-testid="remove-data-header">Remove data</AlertTitle>
          <Typography variant="body3" component="p" mb={1}>
            You have already uploaded data for this layer. Proceeding with this step will remove it.
          </Typography>
          <Typography variant="body3" component="p">
            Are you sure you want to do this?
          </Typography>
        </Alert>
        <Divider />
        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={2}>
          <Button color="primary" size="small" onClick={handleBack} data-testid="cancel-remove-button">
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={onRemove} sx={{ ml: 1, px: 2 }} data-testid="remove-button">
            Remove
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RemoveData;
